import React, { useMemo, useEffect, useState, useReducer, useRef } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';

import { useUser } from './../../../commons/customHooks/Account'
import {
  useRegisterAwardEntry,
  useClearRegisterAwardEntry,
  useMyAwardEntry,
} from './../../../commons/customHooks/Award'
import { useAlbumDetail } from './../../../commons/customHooks/Album'

import HeaderHs2 from '../../../commons/components/Header/headerHs2';
import MainLayout from '../../../commons/layout/MainLayout';
import RegisterDescription from '../components/RegisterDescription';
import RegisterForm from '../components/RegisterForm';
import ROUTERS from "../../../commons/constans/router";

function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

const AwardRegisterContainer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useUser();
  const [ entry ] = useMyAwardEntry();
  const query = useQuery();
  const [albumDetail, loadingAlbumDetail] = useAlbumDetail(query.get('id'))
  const [loading, handleSubmit, errors, success] = useRegisterAwardEntry();
  const [photoSelected, setPhotoSelected] = useState(null);
  const [initData, setInitData] = useState(null);
  const [hasLocationState, setHasLocationState] = useReducer(p => !p, false);
  const [back, setback] = useState(-1);

  const handleLeftClick = () => {
    if (hasLocationState) {
      navigate(ROUTERS.AWARD);
    } else {
      navigate(back);
    }
  }

  useEffect(() => {
    return () => setInitData(null)
  })

  useEffect(() => {
    if (albumDetail) {
      setPhotoSelected(albumDetail)
      navigate(location.pathname)
      setback(back - 1)
    }
  }, [albumDetail])

  useClearRegisterAwardEntry(initData)

  const goToChildren = (data) => {
    navigate(ROUTERS.CHILDREN_SETTING, {state: {data, photoSelected}});
  }

  const goToAlbum = (data) => {
    navigate(ROUTERS.ALBUM, {state: {selectImage: true, data}});
  }

  useEffect(() => {
    if (location.state?.photoSelected) {
      setPhotoSelected(location.state?.photoSelected)
    }
    if (location.state?.data) {
      setInitData(location.state?.data || {children_id: user.childrens[0]?.id || null})
      navigate(location.pathname, { replace: true });
      setHasLocationState()
    }
  }, [location.state])

  useEffect(() => {
    if (success) {
      navigate(ROUTERS.AWARD);
    }
  }, [success])


  if (entry.id) {
    return <Navigate to={ROUTERS.AWARD} />
  }

  return (
    <>
      <MainLayout
        pageID={'award-signup-page'}
        displayBottomNav={false}
        activeNav={'GIFTBOX'}
      >
        <HeaderHs2
          labelRight={false}
          labelLeft={true}
          title="참여등록"
          handleLabelLeft={() => handleLeftClick()}
        />
        <div className="wrapper">
          <div className="main-award-signup-page">
            <RegisterDescription />
            <RegisterForm
              name={user.nickname} // "뽀로로가 좋아좋아"
              childrens={user.childrens}
              photoSelected={photoSelected}
              goToChildren={goToChildren}
              goToAlbum={goToAlbum}
              handleSubmit={handleSubmit}
              loading={loading}
              errors={errors}
              initData={initData}
            />
          </div>
        </div>
      </MainLayout>
    </>
  );
};

export default AwardRegisterContainer;
